module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/location.svg?16ba4379";